// src/components/Home/Statistics.js
import React from "react";
import { motion } from "framer-motion";

export default function Statistics({ stats }) {
    return (
        <section className="py-20 bg-gradient-to-r from-[#0c2c4d] to-[#082f49] text-white">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                {stats.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: idx * 0.2 }}
                    >
                        <div className="text-4xl font-extrabold">{item.value}</div>
                        <div className="text-lg mt-2">{item.label}</div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
